import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/fast-sell-product/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const FastSellProductStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PENDING]         : 'warning',
    [STATUS.PRICE_OFFER]     : 'info',
    [STATUS.SELLER_SHIPPING] : 'info',
    [STATUS.CURATION]        : 'info',
    [STATUS.VERIFICATION]    : 'info',
    [STATUS.FINANCE_PAYMENT] : 'primary',
    [STATUS.PURCHASED]       : 'success',
    [STATUS.COMPLETE]        : 'success',
    [STATUS.REJECT]          : 'danger',
    [STATUS.CANCELLED]       : 'danger',
    [STATUS.EXPIRED]         : 'danger'
  }

  const colorStatus = colorMap[status] || 'default'

  return (
    <StatusBadge color={ colorStatus } label={ status }/>
  )
}

FastSellProductStatusBadge.propTypes = propTypes

export default FastSellProductStatusBadge
